function appendLink(properties) {
  const link = document.createElement('link');
  Object.assign(link, properties);
  document.head.appendChild(link);
}

export default appendLink;
